import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";

import apiClient from "../../utils/apiClient";
import LoadingSpinner from "../../components/loading-spinner";
import styles from "./TableComponent.module.css";
import server from "../../utils/serverConfig";

export default function AlphaStrategy() {
  const [data, setData] = useState();

  const getData = () => {
    let config = {
      method: "get",
      url: `${server.godseye.baseUrl}alpha_seperated_portfolio`,
    };

    apiClient
      .request(config)
      .then((response) => {
        setData(response.data.holdings);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getData();

    const intervalId = setInterval(getData, 3600000);
    return () => clearInterval(intervalId);
  }, []);

  const alpha100 = data && data.alpha_100;
  const alpha200 = data && data.alpha_200;
  const alpha500 = data && data.alpha_500;

  return (
    <DashboardLayout>
      <div className="flex flex-col relative  w-full min-h-screen">
        <div className="flex flex-row justify-between mt-8 items-center">
          <div className="text-xl text-white px-12">Strategy Data</div>
        </div>
        {data ? (
          <div className="flex flex-row justify-between  mt-8 px-24">
            <div className="">
              <div className="text-white font-semibold text-xl py-4 flex flex-row justify-center">
                {" "}
                Alpha 100
              </div>

              <table className={`${styles.table2}`}>
                <thead>
                  <tr>
                    <th scope="col" className="py-2 px-8">
                      Symbol
                    </th>
                    <th scope="col" className="py-2 px-8">
                      Quantity
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {alpha100 &&
                    alpha100.map((ele, i) => {
                      return (
                        <tr key={i}>
                          <td className="px-8">{ele.Symbol}</td>
                          <td className="px-3 text-right">{ele.Quantity}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <div className="">
              <div className="text-white font-semibold text-xl py-4 flex flex-row justify-center">
                {" "}
                Alpha 200
              </div>
              <table className={`${styles.table2}`}>
                <thead>
                  <tr>
                    <th scope="col" className="py-2 px-8">
                      Symbol
                    </th>
                    <th scope="col" className="py-2 px-8">
                      Quantity
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {alpha200 &&
                    alpha200.map((ele, i) => {
                      return (
                        <tr key={i}>
                          <td className="px-8">{ele.Symbol}</td>
                          <td className="px-3 text-right">{ele.Quantity}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <div className="">
              <div className="text-white font-semibold text-xl py-4 flex flex-row justify-center">
                {" "}
                Alpha 500
              </div>
              <table className={`${styles.table2}`}>
                <thead>
                  <tr>
                    <th scope="col" className="py-2 px-8">
                      Symbol
                    </th>
                    <th scope="col" className="py-2 px-8">
                      Quantity
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {alpha500 &&
                    alpha500.map((ele, i) => {
                      return (
                        <tr key={i}>
                          <td className="px-8">{ele.Symbol}</td>
                          <td className="px-3 text-right">{ele.Quantity}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div className="flex flex-row justify-center py-32">
            <LoadingSpinner />
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
